/**
//  *  Copyright AlpineReplay Inc, 2022. All rights reserved.
//  *  Authors: Brian Bal, Drew Burnett
//  */

// Imports

import { NotAllowedDialog } from "../NotAllowedDialog"
import { ForceLogin } from "../../modules/ForceLogin"
import { Route } from "react-router-dom"
import { Column, Loading } from "trux"
import "./ProtectedRoute.css"
import React from "react"

// Protected Route

const ProtectedRoute = ({
    component: Component,
    permissionsLoaded,
    hasPermissions,
    isLoggedIn,
    dismissLogin,
    ...restOfProps
}) => {
    return (
        <>
            <Route
                {...restOfProps}
                render={(props) => {
                    if (!isLoggedIn && permissionsLoaded){
                        return (
                            <ForceLogin
                                {...props}
                                onClose={dismissLogin}
                                skipRedirectOnCompletion={true}
                            />
                        )
                    } else if (
                        isLoggedIn &&
                        permissionsLoaded &&
                        !hasPermissions
                    ) {
                        return <NotAllowedDialog />
                    } else if (!permissionsLoaded) {
                        return (
                            <Column
                                className="protected-route-loading-container"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Loading />
                            </Column>
                        )
                    }
                }}
            />
            <Route
                {...restOfProps}
                render={(props) => {
                    if (hasPermissions) {
                        return (
                            <Component
                                {...restOfProps}
                                {...props}
                                onClose={dismissLogin}
                            />
                        )
                    } else {
                        return null
                    }
                }}
            />
        </>
    )
}

export { ProtectedRoute }
